'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _resource = require('../resource');

var _resource2 = _interopRequireDefault(_resource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Reports = function (_Resource) {
    (0, _inherits3.default)(Reports, _Resource);

    function Reports() {
        (0, _classCallCheck3.default)(this, Reports);
        return (0, _possibleConstructorReturn3.default)(this, (Reports.__proto__ || (0, _getPrototypeOf2.default)(Reports)).apply(this, arguments));
    }

    (0, _createClass3.default)(Reports, [{
        key: 'get',


        /**
         * @api {get} /v1/reports/:report_id get
         * @apiGroup Reports
         * @apiName get
         * @apiDescription Return status of the given celeryTaskID.
         * @apiParam {Number} report_id
         * @apiExample {js} Example:
         *             gigwalk.reports.get({...})
         */
        value: function get(params) {
            return this.client.get('/v1/reports/' + params.report_id);
        }
    }]);
    return Reports;
}(_resource2.default);

exports.default = Reports;
//# sourceMappingURL=index.js.map